import * as React from 'react';
import { Grid } from 'react-flexbox-grid';
import { compose, withStateHandlers, lifecycle, withHandlers } from 'recompose';
import { default as RenderToggle } from 'material-ui/Toggle';
import * as moment from 'moment';
import { get } from 'lodash';

import Date from '@inqool/uas-web-core/es/components/controls/DateTime/DateTime';
import RemoteAutoComplete from '@inqool/uas-web-core/es/components/controls/AutoCompleteRemote';
import { stringifyObject } from '@utils/utils';
import { mapUrl } from '../Map';

const wrapperStyle = {
  width: '160px'
};
const DATE_FORMAT = 'YYYY-MM-DD';
const layersLabel = 'metropolis:oracle_vehicle_location_points';

const enhance = compose<any, { handleLayers: (layers: any) => void }>(
  withStateHandlers(
    {
      active: false,
      from: moment().subtract(1, 'months').format(DATE_FORMAT),
      to: moment().format(DATE_FORMAT),
      vehicle: ''
    },
    {
      handleStateActive: state => () => ({ ...state, active: !state.active }),
      handleStateFrom: state => from => ({ ...state, from: from && stringifyObject(from) }),
      handleStateTo: state => to => ({ ...state, to: to && stringifyObject(to) }),
      handleStateVehicle: state => vehicle => ({ ...state, vehicle })
    }
  ),
  withHandlers({
    updateUrl:
      ({ handleLayers, layers }) =>
      (newProps, oldProps) => {
        const { from: oldFrom, to: oldTo, vehicle: oldVehicle, active: oldActive } = oldProps;
        const { from: newFrom, to: newTo, vehicle: newVehicle, active: newActive } = newProps;

        if (oldFrom !== newFrom || oldTo !== newTo || oldVehicle !== newVehicle || oldActive !== newActive) {
          if (!newFrom || !newTo || !newVehicle || !newActive) {
            handleLayers(layers.filter(({ layers: label }) => label !== layersLabel));
            return;
          }

          const url = mapUrl + `?viewParams=datetime_from:${newFrom};datetime_to:${newTo};vehicle_id:${newVehicle};`;

          handleLayers([
            ...layers.filter(({ layers: label }) => label !== layersLabel),
            {
              layers: layersLabel,
              url,
              active: true
            }
          ]);
        }
      }
  }),
  lifecycle<any, any>({
    componentDidUpdate(prevProps: any) {
      const { updateUrl } = this.props;
      updateUrl(this.props, prevProps);
    }
  })
);

const View: React.SFC<any> = ({
  handleStateFrom,
  handleStateTo,
  handleStateVehicle,
  handleStateActive,
  from,
  to,
  vehicle,
  active
}) => (
  <div>
    <Grid fluid={true}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', margin: '0 10px', alignItems: 'center' }}>
            <h4 style={{ marginRight: '5px' }}>Aktivovat</h4>
            <RenderToggle toggled={!!active} onToggle={handleStateActive} />
          </div>
          {[
            { label: 'Datum od:', name: 'dateFromVehicle', onChange: handleStateFrom, value: from },
            { label: 'Datum do:', name: 'dateToVehicle', onChange: handleStateTo, value: to }
          ].map(({ label, ...restProps }, i) => (
            <div key={i} style={{ display: 'flex', margin: '0 10px' }}>
              <h4 style={{ marginRight: '5px' }}>{label}</h4>
              <Date wrapperStyle={wrapperStyle} dateOnly={true} {...restProps} />
            </div>
          ))}
          <div style={{ display: 'flex', margin: '0 10px' }}>
            <h4 style={{ marginRight: '5px' }}>Vozidlo</h4>
            <RemoteAutoComplete
              name={'vehicle'}
              value={vehicle}
              labelFunction={o => get(o, 'fullName')}
              valueFunction={o => get(o, 'id')}
              placeholder={'Vyberte ze seznamu'}
              onChange={val => handleStateVehicle(val)}
              url="/metropolis/api/cl/vehicles?pageSize=-1"
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            />
          </div>
        </div>
        <div style={{ height: '60px' }} />
      </div>
    </Grid>
  </div>
);

export const MovementVehicles = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/maps/tabs/MovementVehicles.tsx